import React from 'react';
import { PmsConnection } from '../../api.channelManager';
import './channelManager.css';

interface Props {
  connection: PmsConnection | null;
  onAdd: () => void;
  onOpen: () => void;
}

function statusOf(connection: PmsConnection): { label: string; pillClass: string; sub: string } {
  if (!connection.enabled) {
    return { label: 'Needs attention', pillClass: 'cm-pill-danger', sub: connection.lastError || 'The provider rejected the stored token.' };
  }
  if (!connection.hasWebhookSecret) {
    if (connection.secretEnrolmentOpen) {
      return { label: 'Awaiting test reservation', pillClass: 'cm-pill-warn', sub: 'Finish the setup to start syncing' };
    }
    return { label: 'Needs attention', pillClass: 'cm-pill-danger', sub: 'No webhook arrived in time — reopen verification' };
  }
  return {
    label: 'Connected',
    pillClass: 'cm-pill-success',
    sub: `${connection.linkedApartments} apartment${connection.linkedApartments === 1 ? '' : 's'} linked`,
  };
}

const ConnectionListView: React.FC<Props> = ({ connection, onAdd, onOpen }) => {
  if (!connection || !connection.connected) {
    return (
      <div className="cm-empty-state">
        <div style={{ fontSize: '2rem' }}>🔌</div>
        <div style={{ fontWeight: 700, color: 'var(--text-primary)', fontSize: '1.05rem' }}>
          No channel manager connected
        </div>
        <div style={{ color: 'var(--text-muted)', fontSize: '0.88rem', maxWidth: 360 }}>
          Connect Hostex to sync reservations automatically and message guests without leaving Guestbook.
        </div>
        <button type="button" className="app-btn app-btn-green app-btn-standard" style={{ marginTop: 10 }} onClick={onAdd}>
          + Connect a channel manager
        </button>
      </div>
    );
  }

  const status = statusOf(connection);

  return (
    <div>
      <button type="button" className="cm-card" onClick={onOpen}>
        <div className="cm-card-avatar">H</div>
        <div className="cm-card-body">
          <div className="cm-card-title">Hostex</div>
          <div className="cm-card-sub">{status.sub}</div>
        </div>
        <span className={`cm-pill ${status.pillClass}`}>{status.label}</span>
        <span className="cm-chevron">›</span>
      </button>
    </div>
  );
};

export default ConnectionListView;
